import(/* webpackMode: "eager" */ "/tmp/8ded6b2b577299b/src/app/chat/page.tsx");
